import jsPDF from 'jspdf'
import moment from 'moment'


// Create Document Component
export const DealPDFDocGen = (dealDetails) => {
  debugger;
  let globalPDF;
  let positionName = dealDetails.PositionName;
  let projectName = dealDetails.ProjectName;

  let divisionName = dealDetails.DivisionName;
  let releaseType = dealDetails.ReleaseTypeName != null ? ' ( ' + dealDetails.ReleaseTypeName + ' )' : '';
  var doc = new jsPDF();

  var margins = {
    top: 10,
    left: 10,
    width: 545
  };
  let creativeExec = "";
  dealDetails.CreativeExecutives.forEach((creativeExecutive) => {
    creativeExec = creativeExec + ", " + creativeExecutive.CreativeExecutiveName;
  });
  creativeExec = creativeExec.length > 0 ? creativeExec.substring(2, creativeExec.length) : "";

  let finalApprover = "";
  let ccList = "";
  let max_seq = 0;
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  })
  dealDetails.DistributionModels.forEach((recipient) => {
    if (recipient.ActionId == 1 && recipient.Sequence > max_seq) {
      finalApprover = recipient.RecipientName;
      max_seq = recipient.Sequence;
    }
    else if (recipient.ActionId == 2) {
      ccList += ", " + recipient.RecipientName;
    }
    else if (recipient.ActionId == 3) {
      ccList += ", " + recipient.RecipientName;
    }

  });
  ccList = ccList.length > 0 ? ccList.substring(2, ccList.length) : "";
  if (creativeExec != '') {
    ccList += ',    Creative Executive: ' + creativeExec
  }

  let talents = "";
  let representatives = "";

  dealDetails.TalentRepresentativeModels.forEach((talent) => {
    talents = talents + "\n" + talent.TalentModel.TalentName;

    // talent.RepresentativeCompanyModels.forEach((representative) => {
    //   representatives += representative.RepresentativeExtension.RepresentativeName;
    //   representatives += representative.CompanyExtension.CompanyName ? "\n" + representative.CompanyExtension.CompanyName : "";
    //   representatives += representative.CompanyExtension.Address ? "\n" + representative.CompanyExtension.Address : "";
    //   representatives += representative.CompanyExtension.Address2 ? "\n" + representative.CompanyExtension.Address2 : "";
    //   representatives += (representative.CompanyExtension.City ? "\n" + representative.CompanyExtension.City + ", " : "")
    //     + (representative.CompanyExtension.State ? representative.CompanyExtension.State + " " : "")
    //     + (representative.CompanyExtension.zip ? representative.CompanyExtension.zip : "");
    //   representatives += representative.CompanyExtension.Country ? "\n" + representative.CompanyExtension.Country : "";
    //   representatives += "\n";
    // });
  });
  talents = talents.length > 0 ? talents.substring(1, talents.length) : "";

  let writingSteps = "";
  dealDetails.WritingSteps.forEach((writingStep) => {
    writingSteps = writingSteps + "\n" + writingStep.WritingStepsName;
  });
  writingSteps = writingSteps.length > 0 ? writingSteps.substring(1, writingSteps.length) : "";
  let addrText = "";
  let headerText = "";
  let posText = "";
  let roleText = "";
  if (positionName == "Optional Step Form") {
    addrText = "We would like authorization to exercise the following optional writing step:";
    headerText = "Optional Step Request";
    posText = "WRITER";
  }
  else {
    addrText = "We would like authorization for the following deal:";
    headerText = "Deal Request";
    posText = dealDetails.PositionName.toUpperCase();
  }

  if (positionName == "Actor" || positionName == "Actor/Director" || positionName == "Actor/Producer") {
    if (dealDetails.Role && dealDetails.Role != '') {
      roleText = ' - ' + dealDetails.Role;
    }
  }
  let optionalSteps = "";
  if (positionName == "Optional Step Form") {
    dealDetails.OptionalSteps.forEach((optionalStep) => {
      optionalSteps = optionalSteps + "\n" + optionalStep.OptionalStepName;
    });
  }
  optionalSteps = optionalSteps.length > 0 ? optionalSteps.substring(1, optionalSteps.length) : "";
  let producers = "";
  dealDetails.ExistingProducers.forEach((producer) => {
    producers = producers + "\n" + producer.ExistingProducerName;
  });
  producers = producers.length > 0 ? producers.substring(1, producers.length) : "";

  let genres = "";
  dealDetails.Genres.forEach((genre) => {
    genres = (genre ? genres + "\n" + genre.GenreName : "");
  });
  genres = genres.length > 0 ? genres.substring(1, genres.length) : "";

  let materials = "";
  dealDetails.Materials.forEach((material) => {
    materials = (material ? materials + "\n" + material.MaterialName : "");
  });
  materials = materials.length > 0 ? materials.substring(1, materials.length) : "";
  let agents = "";
  let prev = 0;

  let approvers = '';
  let x1_1 = 10, x1_2 = 40;
  let x2_2 = 65;
  let posX = 90;
  doc.addImage('data:image/png;base64,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', 'PNG', 15, 10, 20, 20)
  doc.setFontSize(14)
  doc.setFontType('bold');
  doc.text(posX, prev += 17, headerText);
  let urgentComp = "";

  if (dealDetails.IsUrgent && dealDetails.IsUrgent == true) {
    urgentComp = "URGENT";
    if (positionName == "Optional Step Form")
      posX = 105;
    else
      posX = 95;
  }

  if (dealDetails.IsCompetitive && dealDetails.IsCompetitive == true) {
    if (positionName == "Optional Step Form") {
      if (urgentComp != "")
        posX = 89;
      else
        posX = 99;
    }
    else {
      if (urgentComp != "")
        posX = 77;
      else
        posX = 89;
    }
    urgentComp += (urgentComp != "" ? "/" : "") + "COMPETITIVE";

  }
  if (urgentComp != "") {
    doc.setTextColor(255, 0, 0);
    doc.text(posX, prev += 7, urgentComp);
  }
  doc.setFontSize(10);
  doc.setTextColor(0, 0, 0);
  doc.setFont("acumin-pro-condensed");
  doc.setFontType('normal');
  doc.text(x1_1, prev += 20, 'Date:');
  doc.text(x1_2, prev, new Date(dealDetails.CreatedDate).toLocaleDateString());
  doc.text(x1_1, prev += 7, 'To:');
  doc.text(x1_2, prev, finalApprover);
  doc.text(x1_1, prev += 7, 'From:');
  doc.text(x1_2, prev, creativeExec);
  doc.setFontType('bold');
  doc.text(x1_1, prev += 7, 'Re:');

  let posRoleText = "\"" + projectName + "\"" + ((projectName.length + talents.length) > 50 ? "\n" : "") +
    " - " + talents.replace(/(?:\\[rn]|[\r\n]+)+/g, ", ") + " (" + posText + roleText + ")"

  posRoleText = doc.splitTextToSize(posRoleText, 135);

  doc.text(x1_2, prev, posRoleText);

  doc.setFontType('normal');
  doc.text(x1_1, prev += 7, 'Division:');

  // let posRoleText = "\"" + projectName + "\"" + ((projectName.length + talents.length) > 50 ? "\n" : "") +
  //   " - " + talents.replace(/(?:\\[rn]|[\r\n]+)+/g, ", ") + " (" + posText + roleText + ")"

  // posRoleText = doc.splitTextToSize(posRoleText, 135);

  doc.text(x1_2, prev, divisionName + releaseType);

  doc.setFontType('normal');


  //doc.text(x1_1, 58, 'Created Date:');  
  doc.text(x1_1, prev += 10, addrText);


  if (positionName == "Optional Step Form") {
    doc.text(x1_1, prev += 8, 'Project:');
    doc.text(x2_2, prev, dealDetails.ProjectName);
    doc.text(x1_1, prev += 7, 'Writer:');
    doc.text(x2_2, prev, talents);
    let lenw = talents.split(/\r\n|\r|\n/).length;
    prev = prev + lenw * 3.5;
    doc.text(x1_1, prev += 7, 'Optional Step/Fee:');
    doc.text(x2_2, prev, optionalSteps + "/" + (dealDetails.Fee ? formatter.format(dealDetails.Fee) : ""));
    let len1 = optionalSteps.split(/\r\n|\r|\n/).length;
    prev = prev + len1 * 3.5;
    doc.text(x1_1, prev += 7, 'Last Step Written:');
    doc.text(x2_2, prev, (dealDetails.LastStepWrittenName ? dealDetails.LastStepWrittenName : ""));
  }
  else {
    //let talents = "";
    let i = 1;
    let pos = 20;
    let y1 = prev;
    //let y2 = prev;
    dealDetails.TalentRepresentativeModels.forEach((talent) => {
      //talents = talents + ", " + talent.TalentModel.TalentName;
      let talentName = talent.TalentModel.TalentName;
      doc.setFontType('bolditalic');
      doc.text(x1_1, prev += 7, 'Talent Name:');
      doc.setFontType('normal');
      doc.text(x1_2, prev, talentName);
      let len = talentName.split(/\r\n|\r|\n/).length;
      prev += 7;
      i = 1;
      pos = 20;
      y1 = prev;
      talent.RepresentativeCompanyModels.forEach((representative) => {
        if (representative.RepresentativeExtension.RepresentativeName != null) {
          let representatives = "";
          //This is to handle split-up of two representatives in the same row
          if (i % 2 == 1) {
            pos = x1_1;
          }
          else
            pos = x1_1 + 100;

          doc.setFontType('bold');
          doc.text(pos, prev, representative.RepresentativeExtension.RepresentativeTypeName ? representative.RepresentativeExtension.RepresentativeTypeName : '');
          representatives += representative.RepresentativeExtension.RepresentativeName ? representative.RepresentativeExtension.RepresentativeName : '';
          representatives += representative.CompanyExtension.CompanyName ? "\n" + representative.CompanyExtension.CompanyName : "";
          representatives += representative.CompanyExtension.Address ? "\n" + representative.CompanyExtension.Address : "";
          representatives += representative.CompanyExtension.Address2 ? "\n" + representative.CompanyExtension.Address2 : "";
          representatives += (representative.CompanyExtension.City ? "\n" + representative.CompanyExtension.City + ", " : "")
            + (representative.CompanyExtension.State ? representative.CompanyExtension.State + " " : "")
            + (representative.CompanyExtension.zip ? representative.CompanyExtension.zip : "");
          representatives += representative.CompanyExtension.Country ? "\n" + representative.CompanyExtension.Country : "";
          representatives += representative.RepresentativeExtension.Phone1 ? "\n" + 'Tel: ' + representative.RepresentativeExtension.Phone1 : "";
          representatives += representative.RepresentativeExtension.Phone2 ? "\n" + 'Tel2: ' + representative.RepresentativeExtension.Phone2 : "";
          representatives += representative.RepresentativeExtension.Email ? "\n" + 'Email: ' + representative.RepresentativeExtension.Email : "";
          representatives += representative.RepresentativeExtension.Fax ? "\n" + 'Fax: ' + representative.RepresentativeExtension.Fax : "";
          representatives += "\n";
          representatives += "\n";
          doc.setFontType('normal');
          //doc.text( (pos + 30), prev, representatives);
          let splitDetails = representatives;
          console.log("Rep: " + splitDetails);
          var splitDetailsObj = doc.splitTextToSize(splitDetails, 70);
          doc.text((pos + 30), prev, splitDetailsObj);
          len = splitDetails.length / 90 + (splitDetails.split(/\r\n|\r|\n/).length - 1);

          let len = representatives.split(/\r\n|\r|\n/).length;

          if (i % 2 == 0) {
            prev = prev + len * 4;
            if (y1 > prev)
              prev = y1;
          }
          else
            y1 = prev + len * 4;

          i++;
        }
      });
      if (y1 > prev)
        prev = y1;
      //prev = prev + len * 3.5;

    });


  }

  if (positionName == "Writer" || positionName == "Writer/Director"
    || positionName == "Writer/Producer" || positionName == "Writer/Producer/Director") {
    doc.text(x1_1, prev += 12, 'Writing Steps:');
    doc.text(x2_2, prev, writingSteps);
    let len = writingSteps.split(/\r\n|\r|\n/).length;
    prev = prev + len * 3.5;

    doc.text(x1_1, prev += 7, 'One Step Guarantee Only:');
    doc.text(x2_2, prev, (dealDetails.OneStepGuarenteeOnly ? "Yes" : "No"));
  }
  doc.text(x1_1, prev += 7, 'Existing Producer:');
  doc.text(x2_2, prev, producers);
  let len = producers.split(/\r\n|\r|\n/).length;
  prev = prev + len * 3.5;

  if (positionName != "Optional Step Form") {
    // doc.text(x1_1, prev += 7, 'Brand:');
    // doc.text(x1_2, prev, dealDetails.Brand);
    doc.text(x1_1, prev += 7, 'Brand:');
    doc.text(x2_2, prev, (dealDetails.BrandName ? dealDetails.BrandName : ""));

    doc.text(x1_1, prev += 7, 'Genre:');
    doc.text(x2_2, prev, genres);
    let len = genres.split(/\r\n|\r|\n/).length;
    prev = prev + len * 3.5;

    doc.text(x1_1, prev += 7, 'Special Category:');
    doc.text(x2_2, prev, (dealDetails.SpecialCategoryName ? dealDetails.SpecialCategoryName : ""));
  }

  if (positionName == "Rights") {
    doc.text(x1_1, prev += 7, 'Material:');
    doc.text(x2_2, prev, materials);
    let len = materials.split(/\r\n|\r|\n/).length;
    prev = prev + len * 3.5;

    doc.text(x1_1, prev += 7, 'Fiction/Nonfiction:');
    doc.text(x2_2, prev, (dealDetails.FictionName ? dealDetails.FictionName : ""));

  }
  //var pageHeight = doc.internal.pageSize.height;
  // Before adding new content
  var y = 225 // Height position of new content
  if (prev > 225) {
    doc.addPage();
    y = 0 // Restart height position
    prev = 0;
  }
  doc.text(x1_1, prev += 7, 'Comments:');
  let comments = dealDetails.Comments;
  var splitComments = doc.splitTextToSize(comments, 135);
  //doc.text(15, 20, splitComments)
  doc.text(x2_2, prev, splitComments);
  len = comments.length / 90 + (comments.split(/\r\n|\r|\n/).length - 1);
  prev = prev + len * 3.5;
  doc.text(x1_1, prev += 7, 'Business Affairs Executive:');
  doc.text(x2_2, prev, (dealDetails.BAExecutiveName ? dealDetails.BAExecutiveName : ""));
  doc.text(x1_1, prev += 7, 'AUTHORIZED:');
  doc.text(x2_2, prev, "");



  for (const [index, val] of dealDetails.DealStatusHistory.entries()) {
    if (val.DealAction == "Approved" || val.DealAction == "Pending Approval") {
      doc.setFontType('normal');
      doc.setTextColor(0, 0, 0);
      doc.text(x1_1, prev += 7, val.ActionPerformedBy + ': ');
      if (val.ActionPerformedAt != "" && val.DealAction != "Pending Approval") {
        doc.setFontType('normal');
        doc.setTextColor(0, 0, 255);
        doc.text(x2_2, prev, 'Electronically Signed' + '( '
          + moment(val.ActionPerformedAt).format('MM/DD/YYYY hh:mm A') + ' )');
        if (val.ActionComments != "" && val.ActionComments != null) {
          doc.setTextColor(255, 0, 0);
          doc.setFontType('bold');
          var splitNotes = doc.splitTextToSize(('Notes: ' + val.ActionComments), 135);
          doc.text(x2_2, prev += 5, splitNotes);
          len = val.ActionComments.length / 90 + (val.ActionComments.split(/\r\n|\r|\n/).length - 1);
          prev = prev + len * 4.5;
        }
        // prev = prev + (1) * 4.3;
      }
    }
  }


  doc.setFontType('normal');
  doc.setTextColor(0, 0, 0);
  doc.text(x1_1, prev += 20, 'cc:');

  var ccl = doc.splitTextToSize(ccList, 135);
  doc.text(x2_2, prev, ccl);

  //doc.text(x2_2, prev, ccList);



  globalPDF = doc.output('bloburl');
  window.open(globalPDF, '_blank');

}
//export default DealPDFDocViewer;